import { render } from "./BoxesArea.vue?vue&type=template&id=50da2ff5&scoped=true"
import script from "./BoxesArea.vue?vue&type=script&lang=js"
export * from "./BoxesArea.vue?vue&type=script&lang=js"

import "./BoxesArea.vue?vue&type=style&index=0&id=50da2ff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50da2ff5"]])

export default __exports__